<template>
  <div id="SexManage" class="well" style="padding: 0 1em">
    <b-tabs content-class="mt-3" justified>
      <b-tab :active="dataMode == 0" :disabled="dataMode != 0">
        <table cellpadding="0" cellspacing="0" class="ncut-table-search">
          <tbody>
            <thead class="ncut-thead-menu">
              <tr>
                <th style="min-width: 6em">申請年度：</th>
                <th style="min-width: 5em">
                  <input
                    type="text"
                    onkeyup="this.value=this.value.replace(/[^0-9]/g,'')"
                    onafterpaste="this.value=this.value.replace(/[^0-9]/g,\'\')"
                    onpaste="return false"
                    maxlength="3"
                    v-model="queryInfo.STime"
                    placeholder="如112"
                  />
                </th>
                <th style="min-width: 6em">月份：</th>
                <th style="min-width: 5em">
                  <input
                    type="text"
                    onkeyup="this.value=this.value.replace(/[^0-9]/g,'')"
                    onafterpaste="this.value=this.value.replace(/[^0-9]/g,\'\')"
                    onpaste="return false"
                    maxlength="2"
                    minlength="2"
                    v-model="queryInfo.ETime"
                    placeholder="如01"
                  />
                </th>

                <th style="min-width: 30em" colspan="3">
                  <b-button variant="success" tabindex="3" @click="query()"
                    ><b-icon icon="search" />&nbsp;{{
                      $t("message.Query_cmd")
                    }}</b-button
                  >&nbsp;

                  <a
                    style="margin: 0 0.5rem; text-decoration: none"
                    target="_blank"
                    tabindex="4"
                    class="ncut-excel-style"
                    :href="
                      './WebApi/EconomicDisadvantage/GetSportsODS3/'
                        .concat(queryInfo.STime)
                        .concat(',')
                        .concat(queryInfo.ETime)
                    "
                    v-show="total > 0"
                  >
                    <img
                      src="@/assets/images/ods-file24.png"
                      style="height: 0.8rem"
                    />
                    {{ $t("message.Excel_txt") }}
                  </a>
                </th>
              </tr>
            </thead>
          </tbody>
        </table>

        <div
          class="dataTables_scrollBody"
          style="
            position: relative;
            overflow: auto;

            max-height: 400px;

            width: 100%;
            border-bottom: 1px solid #111;
            border-top: 1px solid #111;
          "
        >

          <table
            class="ncut-table-menu-striped ncut-table-menu"
            bgcolor="#FFFFFF"
          >
            <thead class="ncut-thead-menu">
              <tr>
                <th style="min-width: 2.5em">日期</th>
                <th style="min-width: 5em">每日經費總計</th>

                <th style="min-width: 7em" colspan="2">身分別</th>

                <th style="min-width: 7em">每日小計</th>
              </tr>
              <tr>
                <th style="min-width: 2.5em" rowspan="2"></th>

                <th style="min-width: 5em" rowspan="2"></th>

                <th style="min-width: 3.5em">男學生</th>
                <th style="min-width: 3.5em">女學生</th>
                <th style="min-width: 7em" rowspan="2"></th>
              </tr>
            </thead>
            <tbody class="ncut-tbody-menu">
              <tr
                v-for="(item, index) in docRecordList"
                :key="item.monthDay"
                :index="item.monthDay"
                :name="item.monthDay"
                v-bind:style="{
                  background: selectedRowIndex == index ? headerColor : '',
                }"
                @click="selectedRowIndex = index"
              >
                <td style="text-align: right">
                  {{ item.monthDay }}
                </td>
                <td style="text-align: left">{{ item.amount }}</td>
                <td style="text-align: left">{{ item.man }}</td>
                <td style="text-align: left">{{ item.women }}</td>
                <td style="text-align: left">{{ item.subTotal }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script  id="modal-template">
import * as tools from '../tool'
export default {
  name: 'SexManage',
  data () {
    return {
      total: 0,
      dataMode: 0,
      currentPage: 1,
      selectedRowIndex: 0,
      editId: 0,
      pageSize: 10,
      queryInfo: {
        STime: null,
        ETime: null,
        dataMode: 0
      },
      docRecordList: null
    }
  },

  computed: {
    sysId () {
      return this.$store.getters.getSysId
    },
    setting () {
      return this.$store.getters.getSetting
    },

    filteredDocs: function () {
      let data = []
      if (this.docRecordList != null) {
        data = this.docRecordList.slice(
          (this.currentPage - 1) * this.pageSize,
          this.currentPage * this.pageSize
        )
      }
      return data
    },
    headerColor () {
      return '#f7e8aa'
    }
  },
  filters: {},
  methods: {
    checkSaveData () {
      let msg = ''
      if (this.queryInfo.STime == null) msg = '請輸入申請年度'
      if (this.queryInfo.ETime == null) msg = '請輸入月份'

      return msg
    },
    query () {
      var msg = this.checkSaveData()
      if (msg.length == 0) {
        const vm = this
        vm.docRecordList = null
        vm.total = 0
        vm.queryInfo.dataMode = vm.dataMode

        this.$http
          .put('./WebApi/EconomicDisadvantage/GetSportsList2', vm.queryInfo)
          .then((response) => {
            if (response.data != null) {
              vm.docRecordList = response.data
              vm.total = vm.docRecordList.length
            }
          })
          .catch(function (error) {
            tools.showAlert(vm, 'danger', '對不起,網路連線失敗' + error)
          })
      } else {
        tools.showAlert(this, 'danger', '對不起,請輸入' + msg)
      }
    }
  },
  created () {
    console.log('======created ReportManageView =====')
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.btn1 {
  color: #e2e1e4;
  background-color: #c1651a;
  border-color: #a7a8bd;
}
.btn2 {
  color: #e2e1e4;
  background-color: #1a3b32;
  border-color: #a7a8bd;
}
.span_text {
  display: block;
  width: 20rem;
  white-space: nowrap;
  overflow: hidden !important;
  text-overflow: ellipsis;
}
</style>
